import { Typography } from '@mui/material'
import { usePlanningStore } from '@planning/AppProvider'
import { ContainerVisit } from '@planning/pages/Order/stores/ContainerVisitItem'
import { CreateOrderPageViewStore } from '@planning/pages/Order/stores/CreateOrderPageViewStore'
import { OrderListStore } from '@planning/pages/Order/stores/OrderListStore'
import { OrderFormStore } from '@planning/pages/Order/V2/stores/OrderFormStore'
import { useTranslate } from '@tolgee/react'
import { RequiredField } from '@tom-ui/ui'
import { observer } from 'mobx-react-lite'
import { FC, useMemo } from 'react'
import { SearchContainerVisitDetailed } from '../../SearchContainerVisitDetailed'

interface IUnitStepProps {
  formStore: OrderFormStore
  createOrderPageViewStore: CreateOrderPageViewStore
  onEditOrder?: (containerVisit: ContainerVisit) => void
  onDeleteOrder?: (containerVisit: ContainerVisit) => Promise<void>
}

const UnitStep: FC<IUnitStepProps> = observer(
  ({ formStore, createOrderPageViewStore, onEditOrder, onDeleteOrder }) => {
    const { t } = useTranslate()
    const { selectOrderViewStore, vesselItemStore, orderItemStore, truckItemStore } =
      usePlanningStore()

    const orderListStore = useMemo(
      () => new OrderListStore(orderItemStore, vesselItemStore, truckItemStore),
      [orderItemStore, truckItemStore, vesselItemStore],
    )

    return (
      <>
        <Typography variant='subtitle1' mb={'1rem'}>
          {t('selectUnit', 'Select unit')} <RequiredField />
        </Typography>

        <SearchContainerVisitDetailed
          listStore={orderListStore}
          viewStore={selectOrderViewStore}
          formStore={formStore}
          createOrderPageViewStore={createOrderPageViewStore}
          onEditOrder={onEditOrder}
          onDeleteOrder={onDeleteOrder}
        />
      </>
    )
  },
)

export default UnitStep
